var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-tile-control"},[_c('custom-expansion-panel',{attrs:{"data":[_vm.panelData]},on:{"change":_vm.callback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }